import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import GroupManager, { GROUP_TYPES } from '../../components/common/group-manager/group-manager';

const GroupsSettingsTab = () => {
    const { user } = useSelector((state) => state.auth);
    const doctorId = user?.user?._id;

    const [type, setType] = useState(GROUP_TYPES[0].key);
    const [count, setCount] = useState(0);
    const typeConfig = GROUP_TYPES.find((t) => t.key === type);

    return (
        <div className="my-profile-layout prescription-settings-page">
            <div className="basic-info profile-panel prescription-settings-panel mb-2 groups-settings">
                <div className="profile-panel__toolbar">
                    <div>
                        <h2 className="profile-panel__title">Groups</h2>
                        <p className="profile-panel__subtitle">{typeConfig.subtitle}</p>
                    </div>
                    {count > 0 && (
                        <span className="groups-settings__count">{count}</span>
                    )}
                </div>

                {/* type pills */}
                <div className="groups-settings__tabs">
                    {GROUP_TYPES.map((t) => (
                        <button
                            key={t.key}
                            type="button"
                            className={`groups-settings__tab ${type === t.key ? 'is-active' : ''}`}
                            onClick={() => setType(t.key)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                <GroupManager doctorId={doctorId} type={type} onCountChange={setCount} />
            </div>
        </div>
    );
};

export default GroupsSettingsTab;
